export default "__VITE_ASSET__BFj_A3DF__"